import React from 'react';

const RegisterPrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <div className="privacy-policy-content">
        <h1>Investor Startup Driver - Privacy Policy and Terms of Service</h1>
        <div className="company-info">A product of SalpTech</div>
        <p className="last-updated"><strong>Last Updated:</strong> March 1, 2025</p>
        
        <section>
          <h2>1. Introduction</h2>
          <p>Welcome to the Investor Startup Driver platform ("Platform"). This Privacy Policy and Terms of Service ("Agreement") governs your use of the investor.startupdriver.co website and related services. By using our Platform or accessing our services, you agree to all the terms and conditions of this Agreement.</p>
        </section>
        
        <section>
          <h2>2. Definitions</h2>
          <ul>
            <li><strong>"We," "us," "our"</strong> refers to Investor Startup Driver.</li>
            <li><strong>"You," "your"</strong> refers to the user of the Platform.</li>
            <li><strong>"Services"</strong> refers to the form creation, evaluation, analysis, and startup ranking services provided by Investor Startup Driver.</li>
            <li><strong>"Content"</strong> refers to any data, text, information, graphics, and materials created, uploaded, or shared on the Platform.</li>
          </ul>
        </section>
        
        <section>
          <h2>3. Account Registration</h2>
          <p>To use the Platform services, you must register for an account. When registering:</p>
          <ul>
            <li>You agree to provide accurate, current, and complete information.</li>
            <li>You agree that you are responsible for maintaining the confidentiality of your login credentials and for all activities that occur under your account.</li>
            <li>You agree to notify us immediately of any unauthorized use of your account.</li>
          </ul>
        </section>
        
        <section>
          <h2>4. Data Collection and Use</h2>
          
          <h3>4.1 Information We Collect</h3>
          <p>We may collect the following types of personal data:</p>
          <ul>
            <li><strong>Registration Information:</strong> Email address, password.</li>
            <li><strong>Form Data:</strong> Forms created by users and responses to these forms.</li>
            <li><strong>Usage Data:</strong> Data related to your Platform usage, session information, clicking behavior.</li>
            <li><strong>Device Information:</strong> IP address, browser type, operating system, device information.</li>
          </ul>
          
          <h3>4.2 Use of Data</h3>
          <p>We may use the information we collect for the following purposes:</p>
          <ul>
            <li>To provide and improve our Services.</li>
            <li>To manage user accounts.</li>
            <li>To conduct analytics and statistical analyses.</li>
            <li>To ensure the security of the Platform.</li>
            <li>To provide personalized content and offers.</li>
            <li>To comply with our legal obligations.</li>
          </ul>
          
          <h3>4.3 Sharing of Data</h3>
          <p>Your personal data may be shared with third parties in the following circumstances:</p>
          <ul>
            <li>With your explicit consent.</li>
            <li>With our service providers (only when necessary to provide our services).</li>
            <li>To comply with legal requirements (when required by court order or legal process).</li>
            <li>In the event of a company merger, sale, or restructuring.</li>
          </ul>
        </section>
        
        <section>
          <h2>5. Privacy Practices</h2>
          
          <h3>5.1 Data Security</h3>
          <p>We implement appropriate technical and organizational measures to protect your personal data. However, please remember that no data transmission or storage over the internet is 100% secure.</p>
          
          <h3>5.2 Data Retention</h3>
          <p>We retain your personal data for as long as necessary to provide our services or to comply with our legal obligations.</p>
          
          <h3>5.3 Cookies and Similar Technologies</h3>
          <p>Our Platform may use cookies and similar tracking technologies to enhance your experience. You can disable cookies through your browser settings, but this may affect the functionality of the Platform.</p>
        </section>
        
        <section>
          <h2>6. User Rights and Responsibilities</h2>
          
          <h3>6.1 User Rights</h3>
          <p>With respect to your personal data, you have the following rights:</p>
          <ul>
            <li>To request access to your data.</li>
            <li>To request correction of inaccurate data.</li>
            <li>To request deletion of your data (under certain conditions).</li>
            <li>To request restriction of our data processing activities.</li>
            <li>To request data portability.</li>
            <li>To opt out of marketing communications.</li>
          </ul>
          
          <h3>6.2 User Responsibilities</h3>
          <p>When using the Platform, you agree:</p>
          <ul>
            <li>To comply with all applicable laws and regulations.</li>
            <li>To respect the rights of others.</li>
            <li>Not to engage in misleading, fraudulent, or deceptive activities.</li>
            <li>Not to interfere with the normal operation of the Platform.</li>
            <li>Not to compromise the security of the Platform.</li>
          </ul>
        </section>
        
        <section>
          <h2>7. Content and Intellectual Property</h2>
          
          <h3>7.1 User Content</h3>
          <p>You retain intellectual property rights to content you share or create on the Platform. However, you grant us the right to use, modify, adapt, reproduce, distribute, and publish this content.</p>
          
          <h3>7.2 Platform Content</h3>
          <p>All other content, logos, trademarks, and other intellectual property rights on the Platform belong to us or our licensors.</p>
        </section>
        
        <section>
          <h2>8. Service Limitations and Changes</h2>
          
          <h3>8.1 Service Changes</h3>
          <p>We reserve the right, at any time and without prior notice:</p>
          <ul>
            <li>To modify, suspend, or terminate the Platform or any service.</li>
            <li>To impose limitations on the use of services.</li>
          </ul>
          
          <h3>8.2 Pricing Changes</h3>
          <p>We reserve the right to change the pricing of our paid services at any time. Price changes will be effective for billing cycles after the change.</p>
        </section>
        
        <section>
          <h2>9. Disclaimers and Liability</h2>
          
          <h3>9.1 Disclaimer of Warranties</h3>
          <p>The Platform and Services are provided "as is" and "as available," without any warranties of any kind, either express or implied, including but not limited to warranties of merchantability, fitness for a particular purpose, or non-infringement.</p>
          
          <h3>9.2 Limitation of Liability</h3>
          <p>To the maximum extent permitted by law, we shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly.</p>
        </section>
        
        <section>
          <h2>10. Indemnification</h2>
          <p>You agree to indemnify, defend, and hold harmless Investor Startup Driver and its officers, directors, employees, and agents from and against all claims, liabilities, damages, losses, costs, expenses, and fees arising from or relating to your use of the Platform or any violation of this Agreement.</p>
        </section>
        
        <section>
          <h2>11. Governing Law and Dispute Resolution</h2>
          <p>This Agreement shall be governed by and construed in accordance with the laws of [Your Jurisdiction], without regard to its conflict of law principles. Any dispute arising from or relating to this Agreement shall be subject to the exclusive jurisdiction of the courts in [Your Jurisdiction].</p>
        </section>
        
        <section>
          <h2>12. Changes to this Agreement</h2>
          <p>We may update this Agreement from time to time. The updated version will be effective as soon as it is accessible. We encourage you to review this Agreement periodically to stay informed of changes.</p>
        </section>
        
        <section>
          <h2>13. Contact Us</h2>
          <p>If you have any questions about this Agreement, please contact us at:</p>
          <ul>
            <li>Email: hello@salptech.com</li>
            <li>Address: Medeniyet Technopark | Ünalan Street D-100 Highway Side Road 34700 Üsküdar/İstanbul</li>
          </ul>
        </section>
        
        <section>
          <h2>14. Acceptance of Terms</h2>
          <p>By registering for an account, accessing, or using our Platform, you acknowledge that you have read, understood, and agree to be bound by this Agreement. If you do not agree to these terms, you must not access or use the Platform.</p>
        </section>
      </div>
    </div>
  );
};

export default RegisterPrivacyPolicy;